<script lang="ts">
	//Services
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Alert, Toggle, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let enabled = settings?.sys?.device?.sys_btn_toggle,
		cache = enabled;

	const handleSave = async () => {
		const newEnabled = !enabled;

		if (cache === newEnabled) return;

		const res: SettingRequest = await gen2Request(device, 'Sys.SetConfig', {
			config: { device: { sys_btn_toggle: newEnabled } },
		});

		if (res.isok) {
			enabled = newEnabled;
			settings.sys.device.sys_btn_toggle = enabled;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: enabled
					? $format('sys_btn_toggle_enabled_toast', {
							default: 'Output control via reset button enabled',
						})
					: $format('sys_btn_toggle_disabled_toast', {
							default: 'Output control via reset button disabled',
						}),
			});
			cache = enabled;
		} else {
			enabled = cache;
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
</script>

<Alert
	heading={$format('sys_btn_toggle_description', {
		default: "Control device's output",
	})}
	class="mb-s"
/>

<Toggle checked={enabled} size="m" on:click={handleSave} id="toggle-sys-btn-toggle">
	{$format('sys_btn_toggle_label', {
		default: 'Enable output control via short press',
	})}
</Toggle>
